import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export const SIGNIN_WITH = 'signin_with';
export const SIGNUP_WITH = 'signup_with';
export const CONTINUE_WITH = 'continue_with';
export const SIGNIN = 'signin';

const GoogleAuthButton = ({ clientId, text, callback }) => {
    useEffect(() => {
        if (window.google?.accounts) {
            window.google.accounts.id.initialize({
                client_id: clientId,
                scope: 'openid email profile',
                text,
                callback,
            });

            window.google.accounts.id.renderButton(document.getElementById('google-button'), {
                theme: 'outline',
                size: 'large',
                logo_alignment: 'center',
            });
        }
    }, [clientId, text, callback]);

    return <div id="google-button"></div>;
};

GoogleAuthButton.propTypes = {
    clientId: PropTypes.string.isRequired,
    text: PropTypes.oneOf([SIGNIN, SIGNIN_WITH, SIGNUP_WITH, CONTINUE_WITH]),
    callback: PropTypes.func.isRequired,
};

GoogleAuthButton.defaultProps = {
    text: CONTINUE_WITH,
};

export default React.memo(GoogleAuthButton);
